import React from 'react';
import Modal from 'react-modal';
import numeral from 'numeral';

Modal.setAppElement(document.getElementById('app'));

const ConfirmRemovalModal = (props) => (
  <Modal
    isOpen={props.showConfirmRemovalModal}
    onRequestClose={props.handleCancelRemoval}
    contentLabel="Delete Expense"
    closeTimeoutMS={200}
    className="modal"
  >
    <h3 className="modal__title">Delete Expense</h3>
    <p className="modal__body">{props.expense.desc} {numeral(props.expense.amount / 100).format('$0,0.00')} ?</p>
    <button className="button button--secondary button--margin-right" onClick={props.handleCancelRemoval}>Cancel</button>
    <button className="button" onClick={props.handleConfirmRemoval}>Delete</button>
  </Modal>
);

export default ConfirmRemovalModal;